import moment from 'moment-timezone';
export const DEFAULT_DATE_TIME_FORMAT = 'Y-MM-DD HH:mm:ss';
export const formatUserDate = (date, displayTimezone) => {
    const timeZone = displayTimezone || moment.tz.guess();
    const tzDate = moment(date).tz(timeZone);
    const formattedDate = tzDate.format(DEFAULT_DATE_TIME_FORMAT);
    const zoneAbbr = tzDate.zoneAbbr();
    return `${formattedDate} ${zoneAbbr}`;
};
export const formatDateInTimePeriod = (startTime, endTime, displayTimezone) => {
    const fmt1 = new Intl.DateTimeFormat('sv', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: displayTimezone,
        timeZoneName: 'short'
    });
    return fmt1.formatRange(new Date(startTime), new Date(endTime
        ? endTime
        : startTime));
};
